import { useCallback } from 'react';
import type { TemplateType } from '@server/trading-templates/schemas/input.schema';
import { useNotifications } from '@client/foundation/notifications/notifications.hook';
import { useTemplateMutations } from '../template-mutations.hook';
import { templateNotifications } from '../template-notifications';

export const useSetDefaultTemplate = () => {
  const { toggleDefaultTemplate } = useTemplateMutations();
  const { notify } = useNotifications();

  const onSetAsDefault = useCallback(
    (templateType: TemplateType) => {
      return async (templateId: string, isDefault: boolean) => {
        try {
          const isSuccess = await toggleDefaultTemplate({
            templateType,
            templateId,
            isDefault
          });

          notify({
            type: isSuccess ? 'success' : 'error',
            message: isSuccess
              ? isDefault
                ? templateNotifications.defaultCleared()
                : templateNotifications.defaultSet()
              : templateNotifications.defaultUpdateFailed()
          });

          return isSuccess;
        } catch (error) {
          notify({
            type: 'error',
            message: templateNotifications.defaultUpdateFailed()
          });
          return false;
        }
      };
    },
    [notify, toggleDefaultTemplate]
  );

  return { onSetAsDefault };
};
